
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-wallet/web/how-to-create-wallet-in-komodo-web-wallet",
      function () {
        return require("private-next-pages/docs/komodo-wallet/web/how-to-create-wallet-in-komodo-web-wallet/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-wallet/web/how-to-create-wallet-in-komodo-web-wallet"])
      });
    }
  